// extracted by mini-css-extract-plugin
export var container = "_jg-0";
export var content = "_jg-3";
export var customerTitle = "_jg-4";
export var empty = "_jg-5";
export var gray = "_jg-6";
export var header = "_jg-7";
export var info = "_jg-8";
export var loading = "_jg-2";
export var loadingCard = "_jg-9";
export var oneLine = "_jg-a";
export var personName = "_jg-e";
export var pillContainer = "_jg-b";
export var selected = "_jg-1";
export var text = "_jg-c";
export var twoLines = "_jg-d";
export var unread = "_jg-f";
export var unreadIndicator = "_jg-g";